module.exports = __webpack_public_path__ + "static/img/it.74736d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/it.png
// module id = 1x4m
// module chunks = 18